// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0
import type { ContactPoint, Patient } from '@medplum/fhirtypes';

export function getTelecom(patient: Patient, system: ContactPoint['system']): string {
  return patient.telecom?.find((contact) => contact.system === system)?.value ?? '';
}

export function setTelecom(patient: Patient, system: ContactPoint['system'], value: string): ContactPoint[] {
  const remaining = patient.telecom?.filter((contact) => contact.system !== system) ?? [];
  return value ? [...remaining, { system, value }] : remaining;
}
